import React from 'react';
import { Helmet } from 'react-helmet-async';

const PrivacyPolicy = () => {
  return (
    <div className="w3-container w3-margin">
      <Helmet>
        <title>Privacy Policy - Kayannou</title>
        <meta name="description" content="Privacy Policy for Kayannou unit conversion tools. Learn how we collect, use, and protect your data." />
        <meta name="robots" content="index, follow" />
      </Helmet>

      <div className="w3-card-4 w3-white w3-margin">
        <div className="w3-container w3-orange">
          <h1>Privacy Policy</h1>
        </div>

        <div className="w3-container w3-padding">
          <p><strong>Last updated:</strong> {new Date().toLocaleDateString()}</p>

          <h2>Information We Collect</h2>
          <p>
            Kayannou is committed to protecting your privacy. We collect minimal information
            to provide and improve our services:
          </p>
          <ul>
            <li><strong>Usage Data:</strong> We may collect information about how you use our website, including pages visited and conversion tools used.</li>
            <li><strong>Device Information:</strong> We may collect information about your device, browser type, and IP address for analytics purposes.</li>
            <li><strong>Cookies:</strong> We use cookies and similar technologies to enhance your experience and for advertising purposes.</li>
          </ul>

          <h2>How We Use Information</h2>
          <p>We use the collected information to:</p>
          <ul>
            <li>Provide and maintain our conversion tools</li>
            <li>Improve user experience and website functionality</li>
            <li>Analyze website usage and trends</li>
            <li>Display relevant advertisements through Google AdSense</li>
          </ul>

          <h2>Google AdSense and Cookies</h2>
          <p>
            We use Google AdSense to display advertisements on our website. Google AdSense uses cookies
            to serve ads based on your prior visits to our website or other websites. You may opt out of
            personalized advertising by visiting <a href="https://www.google.com/settings/ads" target="_blank" rel="noopener noreferrer">Google's Ads Settings</a>.
          </p>

          <h2>Third-Party Services</h2>
          <p>We may use third-party services that collect, monitor and analyze data:</p>
          <ul>
            <li><strong>Google Analytics:</strong> For website analytics and usage tracking</li>
            <li><strong>Google AdSense:</strong> For displaying advertisements</li>
          </ul>

          <h2>Data Security</h2>
          <p>
            We implement appropriate security measures to protect your information. However, no method
            of transmission over the internet is 100% secure.
          </p>

          <h2>Children's Privacy</h2>
          <p>
            Our service is not intended for children under 13. We do not knowingly collect personal
            information from children under 13.
          </p>

          <h2>Changes to This Policy</h2>
          <p>
            We may update this privacy policy from time to time. We will notify users of any changes
            by posting the new policy on this page.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
